import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new23",
  "use": "new23-usage",
  "viewBox": "0 0 13.11 13.71",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.11 13.71\" id=\"new23\"><defs><style>#new23 .cls-1{fill-rule:evenodd}</style></defs><title>编组</title><g id=\"new23_图层_2\" data-name=\"图层 2\"><g id=\"new23_图层_1-2\" data-name=\"图层 1\"><g id=\"new23_编组\"><path id=\"new23_Fill-1\" class=\"cls-1\" d=\"M8.8 9.91a.4.4 0 0 1 0 .8H7v1.1a.4.4 0 1 1-.8 0v-1.1H4.5a.52.52 0 0 1-.4-.2.3.3 0 0 1 0-.4.52.52 0 0 1 .4-.2h1.7v-.5H4.5a.52.52 0 0 1-.4-.2.3.3 0 0 1 0-.4.52.52 0 0 1 .4-.2h1.2l-1.2-2.2v-.3c0-.1.1-.2.1-.3.2-.1.5-.1.6.1l1.4 2.6h.1L8.1 6a.48.48 0 0 1 .6-.2c.1.1.2.2.2.3v.3L7.7 8.51h1.1a.43.43 0 0 1 .4.4.43.43 0 0 1-.4.4H7v.5h1.8zm-.4-5.8H4.9c-3.9 0-4.9 7.6-4.9 7.6a2 2 0 0 0 1.8 2h9.5a2 2 0 0 0 1.8-2c.1 0-.9-7.6-4.7-7.6zm-3.5-.7h3.3c1 0 1.8-2.2 1.8-2.2C10 .51 9.9 0 8.8 0S7.4.8 6.6.8 5.3.11 4.3 0 3.1.5 3.1 1.2c0 0 .7 2.2 1.8 2.2z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new23.svg
// module id = 7oOj
// module chunks = 6